export default __webpack_public_path__ + "static/media/BET.10e1bfb7.wav";